<template>
  <NuxtPage></NuxtPage>
</template>
<script setup lang="ts">
if (process.client) {
  window.appVerifyEnd = (data: any) => {
    window.dispatchEvent(
      new CustomEvent('sepa-verify-complete', {
        detail: {
          sepaVerifyData: data,
        },
      })
    )
  }
}

provide('configuration', await useFetchConfiguration())
provide('apps', await useFetchApps())
provide('socialMedias', await useFetchSocialMedias())
</script>
